import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { saveCartId } from "../../features/Cart/CartSlice";
import DEFAULT_OPERATIONS from "../CartPage/Cart.gql";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

export const useCreateCart = () => {
  const dispatch = useDispatch();
  const { cartId } = useSelector((state) => state.cartSlice);
  const { createCartMutation } = DEFAULT_OPERATIONS;

  const [CreateEmptyCart, { data }] = useMutation(createCartMutation, {
    onCompleted: (data) => {
      dispatch(saveCartId(data.cartId));
    },
  });

  useEffect(() => {
    if (!cartId) {
      CreateEmptyCart();
    }
  }, [cartId]);

  return {
    data,
  };
};
